import getColor from "@insite/mobius/utilities/getColor";
import { xBaseTheme } from "@stoneage/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        css: css`
            &,
            ul,
            ol {
                font-size: inherit;
                line-height: inherit;

                li {
                    font-size: inherit;
                    line-height: inherit;
                }
            }
        `,
    },
} as xBaseTheme["lists"];
